import { DeliveryStatus, PhysicalMailDeliveryStatus } from 'constants/loanApplication';
import { checkIsRecipientCopy } from 'utils/documents';

const SENT_OR_BEYOND_STATUSES = new Set([
  DeliveryStatus.SENT,
  DeliveryStatus.OPENED,
  DeliveryStatus.SIGNED,
  PhysicalMailDeliveryStatus.MAILED,
  PhysicalMailDeliveryStatus.IN_TRANSIT,
  PhysicalMailDeliveryStatus.DELIVERED,
]);

export const checkIsDocumentSentToBorrower = (deliveryRequests, documentId) =>
  (deliveryRequests || []).some(
    request =>
      request.documentId === documentId &&
      (request.signatureItems || []).some(item => SENT_OR_BEYOND_STATUSES.has(item.status)),
  );

const compareDocumentNames = (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase());

// definitionId -> qualifying popover documents, scoped by that milestone's Optimus
// Document Types selection (empty selection means no documents on purpose).
export const buildMilestoneDocumentsByDefinitionId = ({
  presentationSettings,
  documents,
  documentTypes,
  deliveryRequests,
}) => {
  const documentList = Object.values(documents || {}).filter(
    doc => !doc.isDeleted && !checkIsRecipientCopy(doc),
  );

  return Object.values(presentationSettings || {}).reduce((acc, setting) => {
    const typeIds = new Set(setting.adminPanelDocumentTypeIds || []);

    acc[setting.id] = typeIds.size
      ? documentList
          .filter(doc => typeIds.has(doc.documentTypeId))
          .map(doc => ({
            id: doc.id,
            // fileName is the raw storage name ({loanId}_{typeId}_{date}); the type name is
            // the human-readable label the Documents tab shows for the same file.
            name: documentTypes?.[doc.documentTypeId]?.documentTypeName ?? doc.fileName ?? '',
            attachedDate: doc.createdDate,
            isSentToBorrower: checkIsDocumentSentToBorrower(deliveryRequests, doc.id),
          }))
          .sort(compareDocumentNames)
      : [];

    return acc;
  }, {});
};
